<template>
  <div class='animated fadeIn'>
    <b-row>
      <b-col md='6'>
        <b-card>
          <div slot='header'>
            <strong><i class="fa fa-align-justify"></i> Créer un nouveau statut</strong>
          </div>
          <b-form-group
              label="Catégorie"
              label-for="basicSelect"
            >
              <b-form-select
                id="basicSelect"
                :options="categoryOptions"
                v-model="categorySelected"
                :class="{hasError: errors.categorySelected !== ''}"
              ></b-form-select>
              <span class='field-error'>{{ errors.categorySelected }}</span>
          </b-form-group>
          <b-form-group
              description='Libelle du statut vu côté client'
              label='Libelle client'
              label-for='Libelle_front'
            >
            <b-form-input id='libelle_front' type='text' :class="{hasError: errors.libelle_front !== ''}" v-model="libelle_front"></b-form-input>
            <span class='field-error'>{{ errors.libelle_front }}</span>
          </b-form-group>
          <b-form-group
              description='Libelle du statut vu côté gestionnaire'
              label='Libelle gestionnaire'
              label-for='Libelle_bo'
            >
            <b-form-input id='libelle_bo' type='text' :class="{hasError: errors.libelle_bo !== ''}" v-model="libelle_bo"></b-form-input>
            <span class='field-error'>{{ errors.libelle_bo }}</span>
          </b-form-group>
          <b-form-group
              label='Libelle technique'
              label-for='tec_label_bo'>
            <b-form-input id='tec_label_bo' type='text' :class="{hasError: errors.libelle_technique !== ''}" v-model="libelle_technique"></b-form-input>
            <span class='field-error'>{{ errors.libelle_technique }}</span>
          </b-form-group>
          <b-form-group
              label='Parent'
              label-for='parent_id'>
            <b-form-select v-model="selectedParent" :options="allParents">
              <template v-if="categorySelected === ''" v-slot:first>
                <b-form-select-option value="needCategory">Veuillez d'abord sélectionner une catégorie</b-form-select-option>
              </template>
              <template v-else v-slot:first>
                <b-form-select-option value="null">-- Aucun parent --</b-form-select-option>
              </template>
            </b-form-select>
          </b-form-group>
          <b-form-group  v-if="showCritereSup"
            label='Critère de priorité'
            label-for='critere_priorite'>
            <b-form-input id='critere_priorite' type='number' min="0" :class="{hasError: errors.critere_priorite !== ''}" v-model="critere_priorite"></b-form-input>
            <span class='field-error'>{{ errors.critere_priorite }}</span>
          </b-form-group>
          <b-form-group
            label='Ordre'
            label-for='ordre'>
            <b-form-input id='ordre' type='number' min="0" v-model="ordre"></b-form-input>
          </b-form-group>
          <b-form-group  v-if="showCritereSup"
            label='Libellé destinataire'
            label-for='libelle_destinataire_ps'>
            <b-form-input id='libelle_destinataire_ps' type='text' :class="{hasError: errors.libelle_destinataire_ps !== ''}" v-model="libelle_destinataire_ps"></b-form-input>
            <span class='field-error'>{{ errors.libelle_destinataire_ps }}</span>
          </b-form-group>
          <b-form-group v-if="showCritereSup" label="traitement secondaire"
                        label-for="traitement_secondaire">
            <b-form-select
              id="traitement_secondaire"
              :class="{hasError: errors.traitementSelected !== ''}"
              :options="traitementOptions"
              v-model="traitementSelected">
            </b-form-select>
            <span class='field-error'>{{ errors.traitementSelected }}</span>
          </b-form-group>
          <b-row class="mb-1">
            <b-col sm="6">
              <label for="has_reopen_traitement_secondaire"><strong>Réouvre le dossier dans le traitement secondaire</strong></label>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <b-form-checkbox v-model="has_reopen_traitement_secondaire"></b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <b-form-group label="Type">
            <multiselect v-model="selectedTypes"
                         :class="{hasError: errors.types !== ''}"
                         tag-placeholder="Choisissez un type"
                         placeholder="Choisissez un type"
                         label="name"
                         track-by="id"
                         :options="allTypes"
                         :multiple="true"
                         :taggable="true">
            </multiselect>
            <span class='field-error'>{{ errors.types }}</span>
          </b-form-group>
          <div slot="footer">
            <b-button type="button" @click="returnBack" size="md" variant="secondary">
              <i class="fa fa-arrow-left"></i> Liste des statuts
            </b-button>
            <b-button type="button" @click="add" size="md" class="pull-right" variant="primary">
              <i class="fa fa-save"></i> Enregistrer
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '@/utils/auth';
import { isEmpty } from "@/utils/fileHelper";
import Multiselect from 'vue-multiselect';

export default {
  data() {
    return {
      libelle_front: '',
      libelle_bo: '',
      libelle_technique: '',
      selectedParent: 'needCategory',
      allStatus: [],
      allParents: [],
      critere_priorite: '',
      ordre: '',
      libelle_destinataire_ps: '',
      showCritereSup: false,
      errors: {
        libelle_front: '',
        libelle_bo: '',
        libelle_technique: '',
        categorySelected: '',
        critere_priorite: '',
        libelle_destinataire_ps: '',
        types: '',
        traitementSelected: '',
      },
      categoryOptions: [],
      categorySelected: '',
      traitementOptions: [],
      traitementSelected: null,
      selectedTypes: [],
      allTypes: [],
      categories:[],
      has_reopen_traitement_secondaire: false,
    }
  },
  components: {
    Multiselect,
  },
  watch: {
    categorySelected: function() {
      this.getParents(this.categorySelected)
      this.selectedParent = null
    },
    selectedParent() {
      if (!isEmpty(this.allStatus)) {
        const statutParent = _.find(this.allStatus, (parent) => { return parseInt(parent.id,10) === parseInt(this.selectedParent,10) });

        this.showCritereSup = (statutParent.libelle_technique === 'en_attente') ? true : false;
      }
    },
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl()
    this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
    this.$axios.defaults.headers.common['Accept'] = 'application/json'
    this.$axios.defaults.headers.common['Provider'] = getProvider()

    this.allCategory()

  },
  async mounted() {
    this.getTraitementsSecondaires();
    await this.getTypes();
  },
  methods: {
    allCategory() {
      // Récupérer la liste de tous les catégories
      this.$axios
        .get("/administration/categories")
        .then(response => {
          this.categories= response.data.categories;
          for (let i = 0; i < this.categories.length; i++) {
            this.categoryOptions.push({
              text: this.categories[i].libelle,
              value: this.categories[i].id
            });
          }
        })
        .catch(function(error) {
        });
    },
    getParents(categoryId) {
      // Récupérer la liste de tous les statuts parents pour cette catégorie
      this.$axios
        .get('/administration/statuts/getParents/'+categoryId)
        .then(response => {
          this.allStatus = response.data.status;
          let statuts = response.data.status;
          for (let statut of statuts) {
            this.allParents.push({
              text: statut.libelle_bo,
              value: statut.id
            });
          }
        })
        .catch(function(error) {
        });
    },
    add() {
      if (this.validateData()) {
        this.$store.commit('IS_LOADING', true)
        let self = this
        let dataPost = {}
        dataPost.libelle_front = this.libelle_front
        dataPost.libelle_bo = this.libelle_bo
        dataPost.libelle_technique = this.libelle_technique
        dataPost.parent_id = this.selectedParent;
        dataPost.category = this.categorySelected;
        dataPost.critere_priorite = this.critere_priorite;
        dataPost.ordre = this.ordre;
        dataPost.libelle_destinataire_ps = this.libelle_destinataire_ps;
        dataPost.traitement_ps_id  = this.traitementSelected;
        dataPost.type_status  = this.selectedTypes.map((type) => type.id);
        dataPost.has_reopen_traitement_secondaire  = this.has_reopen_traitement_secondaire;
        this.$axios
          .post("/administration/statuts", dataPost)
          .then(() => {
            this.$store.commit('IS_LOADING', false)
            this.$swal({ position: 'top', type: 'success', title:'Création avec succès', text:'Le statut ' + dataPost.libelle_bo + ' a bien été créé',showConfirmButton: false, timer: 5000});
            this.clearForm();
            this.returnBack()
          })
          .catch(function(error) {
            let text = 'Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI.';
            if (error.response && error.response.data) {
              const reg = /clé dupliquée/;
              if (reg.test(error.response.data.message)) {
                text = 'Le libellé technique est déjà utilisé';
              }
            }
            self.$store.commit('IS_LOADING', false)
            self.$swal({ position: 'top', type: 'error', title:'Attention !!', text:text,showConfirmButton: false, timer: 6000})
          });
      }
    },
    returnBack() {
      this.$router.push({ path: '/administration/statuts' })
    },
    validateData () {
      this.clearErrors();
      const categoryStatutDossier = _.find(this.categories, (category) => { return category.libelle_technique === 'status_dossier' });
      const typeStatus = this.selectedTypes.map((type) => type.id);
      let regAlpha = this.$store.getters.getRegAlpha
      let regAlphaUnderscore = this.$store.getters.getRegAlphaUnderscore
      let valid = true
      if (this.libelle_front.trim() === ''){
        this.errors.libelle_front = 'Le libelle pour le client est obligatoire'
        valid= false
      }
      if (this.libelle_bo.trim() === ''){
        this.errors.libelle_bo = 'Le libelle pour le gestionnaire est obligatoire'
        valid= false
      }
      if (this.libelle_technique.trim() === '') {
        this.errors.libelle_technique = 'Le libelle technique est obligatoire'
        valid= false
      }
      if (this.categorySelected === ''){
        this.errors.categorySelected = 'La catégorie est obligatoire'
        valid= false
      }
      if (parseInt(categoryStatutDossier.id) === parseInt(this.categorySelected) && typeStatus.length === 0){
        this.errors.types = 'Vous devez choisir au moins un type'
        valid= false
      }
      // Si statut parent = en attente, d'autres champs sont obligatoire
      let statutParent = _.find(this.allStatus, (parent) => { return parseInt(parent.id,10) === parseInt(this.selectedParent,10) });

      if (!isEmpty(statutParent) && statutParent.libelle_technique === 'en_attente') {
        if (this.critere_priorite.trim() === ''){
          this.errors.critere_priorite = 'Le critère de priorité est obligatoire'
          valid= false
        }

        if (this.libelle_destinataire_ps.trim() === ''){
          this.errors.libelle_destinataire_ps = 'Le libellé du destinataire du traitement secondaire est obligatoire'
          valid= false
        }
        if (this.traitementSelected === null){
          this.errors.traitementSelected = 'Le choix traitement secondaire est obligatoire'
          valid= false
        }
      }

      return valid
    },
    clearErrors() {
      this.errors.libelle_front = ''
      this.errors.libelle_bo = ''
      this.errors.libelle_technique = ''
      this.errors.categorySelected = ''
    },
    clearForm() {
      this.libelle_front = ''
      this.libelle_bo = ''
      this.libelle_technique = ''
      this.selectedParent = 'needCategory';
      this.categorySelected = '';
      this.critere_priorite = '';
      this.ordre = '';
      this.libelle_destinataire_ps = '';
      this.traitement_ps_id  = null;
    },
    getTraitementsSecondaires() {
      this.$axios
        .get("/administration/traitements_secondaires")
        .then(response => {
          const traitements = response.data.data ? response.data.data : [];
          for (let i = 0; i < traitements.length; i++) {
            this.traitementOptions.push({
              text: traitements[i].libelle,
              value: traitements[i].id
            });
          }
        })
        .catch((error) => {
          console.log(error)
        });
    },
    async getTypes() {
      let self = this
      this.$store.commit("IS_LOADING", true)
      await this.$axios
        .get("/administration/statuts/typesStatus")
        .then(response => {
          this.$store.commit("IS_LOADING", false)
          for(let type of response.data.data){
            this.allTypes.push({id: type.id, name: type.libelle})
          }
        })
        .catch(function() {
          self.$store.commit("IS_LOADING", false)
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support",
            showConfirmButton: false,
            timer: 5000
          })
        });
    },
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
